import styles from "./styles";
import { HeaderSearch } from "../../components/HeaderSearch";
import { useRef, useState } from "react";
import {
  getFormattedFullName,
  getFormattedNumber,
} from "../../utils/handler_validations";
import { DivTablePage } from "../../components/common/DivTablePage";
import { classVeryIconGoogle } from "../../components/common/v2/VeryIconGoogle/classVeryIconGoogle";
import { VeryIconGoogle } from "../../components/common/v2/VeryIconGoogle";
import { Tooltip } from "@mui/material";
import { VeryBtnFill } from "../../components/common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../components/common/v2/VeryBtnFill/classVeryBtnFill";
import { useDriversContext, useFormDriverContext } from "../../context";
import { useSessionContext } from "../../context/session.context";
import { driverDB } from "../../services";
import { VeryTable } from "../../components/common/v2/VeryTable";
import classVeryTable from "../../components/common/v2/VeryTable/classVeryTable";
import { ModalAsk } from "../../components/common/ModalAsk";
import { PanelProfile } from "../../components/drivers-page/PanelProfile";
import { CellTooltip } from "../../components/common/v2/VeryTable/CellTooltip";
import StylesCellTooltip from "../../components/common/v2/VeryTable/CellTooltip/styles";
import { useVeryNotificationsContext } from "../../components/common/v2/VeryNotifications/useVeryNotifications";

const renderHeaderWithTooltip = (label, fullTitle) => () => (
  <Tooltip title={fullTitle} placement="top" arrow>
    <span style={{ cursor: "help", display: "inline-flex", alignItems: "center", fontWeight: "bold" }}>
      {label}
    </span>
  </Tooltip>
);

const ContentDriversPage = () => {
  const notis = useVeryNotificationsContext();
  const formDriver = useFormDriverContext();
  const drivers = useDriversContext();
  const refDivMain = useRef();
  
  const session = useSessionContext();
  const [filterWithBalance, setFilterWithBalance] = useState(false);
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    driverId: 0,
    driverName: "",
    totalBalance: 0,
    amount: "",
    comment: "",
    loading: false,
    coupons: [],
    loadingCoupons: false
  });

  const openPaymentModal = async (driverId, driverName, unpaidEarning) => {
    setPaymentModal({
      visible: true,
      driverId,
      driverName,
      totalBalance: unpaidEarning,
      amount: unpaidEarning.toString(),
      comment: "",
      loading: false,
      coupons: [],
      loadingCoupons: true
    });

    try {
      const resp = await driverDB.getDriverUnpaidCoupons(driverId, session.value.jwt);
      if (resp.error) {
        console.error(resp.error);
        setPaymentModal(prev => ({ ...prev, loadingCoupons: false }));
      } else {
        setPaymentModal(prev => ({ 
          ...prev, 
          coupons: resp.body?.coupons || [], 
          loadingCoupons: false 
        }));
      }
    } catch (e) {
      console.error(e);
      setPaymentModal(prev => ({ ...prev, loadingCoupons: false }));
    }
  };

  const handlePayBalance = async () => {
    const payAmt = parseFloat(paymentModal.amount);
    if (isNaN(payAmt) || payAmt <= 0) {
      notis.createNotiError("Monto inválido", "Por favor ingresa un monto válido a pagar");
      return;
    }

    if (payAmt > paymentModal.totalBalance) {
      notis.createNotiError(
        "Monto excedido",
        `El monto a liquidar no puede ser mayor que el saldo pendiente ($${paymentModal.totalBalance.toFixed(2)} MXN)`
      );
      return;
    }
    
    setPaymentModal(prev => ({ ...prev, loading: true }));
    try {
      const resp = await driverDB.payDriverBalance(
        paymentModal.driverId,
        payAmt,
        paymentModal.comment,
        session.value.jwt
      );
      if (resp.error) {
        notis.createNotiError("Error de Pago", resp.error.message || "Error al procesar el pago");
        setPaymentModal(prev => ({ ...prev, loading: false }));
      } else {
        notis.createNotiSuccess("Pago exitoso", "El pago se procesó y liquidó correctamente.");
        setPaymentModal({
          visible: false,
          driverId: 0,
          driverName: "",
          totalBalance: 0,
          amount: "",
          comment: "",
          loading: false,
          coupons: [],
          loadingCoupons: false
        });
        drivers.getListFiltered();
      }
    } catch (e) {
      console.error(e);
      notis.createNotiError("Error de Red", "Error inesperado de comunicación");
      setPaymentModal(prev => ({ ...prev, loading: false }));
    }
  };

  console.log("ContentDriversPage -> drivers", drivers);
  return (
    <>
      <styles.DivMain
        reff={refDivMain}
        isLoading={drivers.value.page.loading}
        error={drivers.value.page.error}
        onClickBtnRetry={() => drivers.getListInitial()}
      >
        {/* HEADER */}
        <HeaderSearch
          inputSearch={{
            placeHolder: "Buscar conductor",
            text: drivers.textInputSearch,
            onChangeText: (newText) => drivers.onChangeTextInputSearch(newText),
            onClick: () => drivers.getListFiltered(),
          }}
        >
          <VeryBtnFill
            CSS={["btnFilterBalance"]}
            colorTheme={filterWithBalance ? classVeryBtnFill.COLOR_THEME.BLACK_S1 : classVeryBtnFill.COLOR_THEME.WHITE_S1}
            label={filterWithBalance ? "Con Saldo" : "Filtrar Saldo"}
            icon={{
              name: "payments",
              size: 18,
              type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
            }}
            onClick={() => setFilterWithBalance(!filterWithBalance)}
          />
          <VeryBtnFill
            CSS={["btnAddDriver"]}
            colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
            icon={{
              name: "group_add",
              size: 18,
              type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
            }}
            onClick={() => formDriver.showModalModeAdd()}
          />
        </HeaderSearch>

        {/* CONTENT */}
        <DivTablePage
          isLoading={drivers.value.contentPage.loading}
          error={drivers.value.contentPage.error}
          emptyMessage={drivers.getEmptyMsgPage()}
          onClickBtnRetry={() => drivers.getListFiltered()}
        >
          {/* DRIVERS TABLE */}
          <VeryTable
            CSS={["driversTable"]}
            rows={filterWithBalance
              ? drivers.value.list.filter(row => drivers.getUnpaidEarning(row.driver?.id) > 0)
              : drivers.value.list
            }
            getRowId={(row) => row.rowId}
            disabledRowSelection={false}
            rowSelected={drivers.rowSelected}
            onChangeRowSelected={(newRowSelected) => {
              drivers.onChangeRowSelected(newRowSelected);
            }}
            columns={{
              // column profile
              col_name: classVeryTable.getColumnTemplate(
                "Conductor",
                "Nombre del conductor",
                1.5,
                180,
                160,
                true,
                true,
                (params) => {
                  return getFormattedFullName(
                    params.row.driver?.name,
                    params.row.driver?.lastName
                  );
                },
                (params) => {
                  return classVeryTable.renderColProfile(
                    params.row.driver?.profileImg,
                    params.value
                  );
                }
              ),
              // column tel
              col_tel: classVeryTable.getColumnTemplate(
                "Teléfono",
                "Teléfono del conductor",
                0,
                115,
                105,
                true,
                true,
                (params) => {
                  return params.row?.driver?.tel;
                },
                (params) => {
                  return classVeryTable.renderColTel(params?.value, " ");
                }
              ),
              // column total trips
              col_trips: classVeryTable.getColumnTemplate(
                "Viajes",
                "Total de viajes realizados",
                0,
                80,
                70,
                true,
                true,
                (params) => {
                  return drivers.getCompletedTrips(params.row.driver?.id);
                },
                (params) => {
                  return classVeryTable.renderColNumber(params?.value, 0);
                },
                renderHeaderWithTooltip("Viajes", "Total de viajes realizados")
              ),
              // column index cancellation
              col_cancellation: classVeryTable.getColumnTemplate(
                "Canc.",
                "Índice de cancelación (Viajes cancelados por el conductor / Atendidos)",
                0,
                85,
                75,
                true,
                true,
                (params) => {
                  return drivers.getCanceledTrips(params.row.driver?.id)
                    .quantity;
                },
                (params) => {
                  const canceledTrips = drivers.getCanceledTrips(
                    params.row.driver?.id
                  );
                  return (
                    <CellTooltip
                      divMainCSS={["cellIndexCancellation"]}
                      divCellCSS={["cell-content"]}
                      contentCell={
                        <>
                          <StylesCellTooltip.LabelCell className="txt-labelCell">
                            {params.value}
                            <label className="txt-slash">/</label>
                            {`${canceledTrips.total}`}
                          </StylesCellTooltip.LabelCell>
                        </>
                      }
                      contentTooltip={
                        <div className="div-contentTooltip">
                          <div className="div-rowTxt">
                            <label className="txt-title">
                              Total de viajes cancelados:
                            </label>
                            <label className="txt-value">{params.value}</label>
                          </div>
                          <div className="div-rowTxt">
                            <label className="txt-title">
                              Total de viajes atendidos:
                            </label>
                            <label className="txt-value">
                              {canceledTrips.total}
                            </label>
                          </div>
                          <div className="div-rowTxt">
                            <label className="txt-title">
                              Porcentaje de cancelación:
                            </label>
                            <label className="txt-value">
                              {getFormattedNumber(
                                (params.value / canceledTrips.total) * 100,
                                false,
                                1
                              )}
                              %
                            </label>
                          </div>
                        </div>
                      }
                    />
                  );
                },
                renderHeaderWithTooltip("Canc.", "Índice de cancelación (Viajes cancelados por el conductor / Atendidos)")
              ),
              // column total earned
              col_total_earned: classVeryTable.getColumnTemplate(
                "Cobrado",
                "Ganancia total del conductor en los viajes finalizados",
                0,
                95,
                85,
                true,
                true,
                (params) => {
                  return drivers.getTripsEarning(params.row.driver?.id);
                },
                (params) => {
                  return classVeryTable.renderColMoney(params?.value, 0);
                },
                renderHeaderWithTooltip("Cobrado", "Ganancia total del conductor en los viajes finalizados")
              ),
              // column unpaid balance (Saldo a favor)
              col_unpaid_earning: classVeryTable.getColumnTemplate(
                "Saldo",
                "Saldo acumulado por cupones pendientes de liquidar",
                0,
                95,
                85,
                true,
                true,
                (params) => {
                  return drivers.getUnpaidEarning(params.row.driver?.id);
                },
                (params) => {
                  return classVeryTable.renderColMoney(params?.value, 0);
                },
                renderHeaderWithTooltip("Saldo", "Saldo acumulado por cupones pendientes de liquidar")
              ),
              // column rating
              col_rating: classVeryTable.getColumnTemplate(
                "Calif.",
                "Calificación del conductor",
                0,
                75,
                65,
                true,
                true,
                (params) => {
                  return drivers.getRating(params.row.driver?.id);
                },
                (params) => {
                  return classVeryTable.renderColRating(params?.value);
                },
                renderHeaderWithTooltip("Calif.", "Calificación del conductor")
              ),
              // column services (Icons only)
              col_services: classVeryTable.getColumnTemplate(
                "Servicios",
                "Servicios que el conductor está autorizado a prestar",
                0,
                90,
                80,
                true,
                true,
                (params) => {
                  const trips = params.row.allowsTrips !== false;
                  const shipments = params.row.allowsShipments !== false;
                  if (trips && shipments) return "Ambos";
                  if (shipments) return "Solo Envíos";
                  if (trips) return "Solo Viajes";
                  return "Ninguno";
                },
                (params) => {
                  const trips = params.row.allowsTrips !== false;
                  const shipments = params.row.allowsShipments !== false;

                  return (
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      {trips && (
                        <Tooltip title="Viajes de Pasajeros (Taxi) Autorizado" placement="top" arrow>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "26px",
                              height: "26px",
                              borderRadius: "6px",
                              backgroundColor: "#f0fdf4",
                              border: "1px solid #86efac",
                              color: "#166534",
                            }}
                          >
                            <VeryIconGoogle
                              name="local_taxi"
                              type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                              size={16}
                            />
                          </div>
                        </Tooltip>
                      )}
                      {shipments && (
                        <Tooltip title="Envíos y Paquetería Autorizado" placement="top" arrow>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "26px",
                              height: "26px",
                              borderRadius: "6px",
                              backgroundColor: "#f0f9ff",
                              border: "1px solid #7dd3fc",
                              color: "#0369a1",
                            }}
                          >
                            <VeryIconGoogle
                              name="inventory_2"
                              type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                              size={16}
                            />
                          </div>
                        </Tooltip>
                      )}
                      {!trips && !shipments && (
                        <Tooltip title="Sin servicios autorizados" placement="top" arrow>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "26px",
                              height: "26px",
                              borderRadius: "6px",
                              backgroundColor: "#fef2f2",
                              border: "1px solid #fecaca",
                              color: "#b91c1c",
                            }}
                          >
                            <VeryIconGoogle
                              name="block"
                              type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                              size={16}
                            />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  );
                },
                renderHeaderWithTooltip("Servicios", "Servicios que el conductor está autorizado a prestar")
              ),
              // column cognito status
              col_cognito_status: classVeryTable.getColumnTemplate(
                "Reg.",
                "Estado del registro del conductor en Cognito",
                0,
                65,
                55,
                true,
                true,
                (params) => {
                  return params.row.driver?.cognitoStatus;
                },
                (params) => {
                  const status = params.value;
                  const isPending = status === "FORCE_CHANGE_PASSWORD";
                  const isConfirmed = status === "CONFIRMED";
                  
                  if (isConfirmed) {
                    return (
                      <Tooltip title="Registro completado (Cuenta confirmada)" placement="top" arrow>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            backgroundColor: "#dcfce7",
                            color: "#15803d",
                            border: "1px solid #86efac",
                          }}
                        >
                          <VeryIconGoogle
                            name="check_circle"
                            type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                            size={16}
                          />
                        </div>
                      </Tooltip>
                    );
                  }
                  if (isPending) {
                    return (
                      <Tooltip title="Registro pendiente (Cambio de contraseña requerido)" placement="top" arrow>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            backgroundColor: "#fef3c7",
                            color: "#b45309",
                            border: "1px solid #fcd34d",
                          }}
                        >
                          <VeryIconGoogle
                            name="schedule"
                            type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                            size={16}
                          />
                        </div>
                      </Tooltip>
                    );
                  }
                  return (
                    <Tooltip title={status || "Desconocido"} placement="top" arrow>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          backgroundColor: "#f3f4f6",
                          color: "#6b7280",
                          border: "1px solid #d1d5db",
                        }}
                      >
                        <VeryIconGoogle
                          name="help"
                          type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                          size={15}
                        />
                      </div>
                    </Tooltip>
                  );
                },
                renderHeaderWithTooltip("Reg.", "Estado del registro del conductor en Cognito")
              ),
              // column enabled
              col_enabled: classVeryTable.getColumnTemplate(
                "Activo",
                "Conductor habilitado / deshabilitado",
                0,
                75,
                65,
                false,
                true,
                (params) => {
                  return drivers.getIsActiveDriver(params.row.driver?.id);
                },
                (params) => {
                  const driverId = params?.row?.driver?.id;
                  return classVeryTable.renderColSwitch(
                    params.value,
                    drivers.getIsLoadingActiveDriver(driverId),
                    () => {
                      const driverName = getFormattedFullName(
                        params.row.driver?.name,
                        params.row.driver?.lastName,
                        "Nombre desconocido"
                      );
                      if (params.value) {
                        drivers.onDisableToDriver(driverId, driverName);
                      } else {
                        drivers.onEnableToDriver(driverId, driverName);
                      }
                    }
                  );
                }
              ),
              // column menu
              col_menu: classVeryTable.getColumnTemplate(
                "",
                "",
                0,
                50,
                45,
                false,
                false,
                undefined,
                (params) => {
                  const menuItems = [
                    {
                      label: "Actualizar perfil",
                      loading: false,
                      onClick: () => {
                        const dataDriver = drivers.getDriverToEdit(params.id);
                        formDriver.showModalModeEdit({
                          // personal data
                          id: dataDriver.id,
                          profileImg: dataDriver.profileImg,
                          name: dataDriver.name,
                          lastName: dataDriver.lastName,
                          email: dataDriver.email,
                          tel: dataDriver.tel,
                          curp: dataDriver.curp || dataDriver.vehicle?.curp || "",
                          // vehicle data
                          vehicleModel: dataDriver.vehicle.model,
                          vehicleYear: dataDriver.vehicle.year,
                          vehicleABS: dataDriver.vehicle.abs,
                          vehicleAirbags: dataDriver.vehicle.airbags,
                          vehicleColor: dataDriver.vehicle.color,
                          vehiclePlates: dataDriver.vehicle.plates,
                          vehicleEconomicNumber:
                            dataDriver.vehicle.economicNumber,
                          vehicleSerialNumber:
                            dataDriver.vehicleSerialNumber ||
                            dataDriver.vehicle?.vehicleSerialNumber ||
                            "",
                          vehicleFrontPhoto: dataDriver.vehicle.frontPhoto,
                          vehicleBackPhoto: dataDriver.vehicle.backPhoto,
                          vehicleLeftPhoto: dataDriver.vehicle.leftPhoto,
                          vehicleRightPhoto: dataDriver.vehicle.rightPhoto,
                          // service capabilities
                          allowsTrips:
                            dataDriver.allowsTrips !== undefined
                              ? dataDriver.allowsTrips
                              : true,
                          allowsShipments:
                            dataDriver.allowsShipments !== undefined
                              ? dataDriver.allowsShipments
                              : true,
                          // documents data
                          ine: dataDriver.documentsDriver.ine,
                          driverLicence:
                            dataDriver.documentsDriver.driverLicence,
                          circulationCard:
                            dataDriver.documentsVehicle.circulationCard,
                          contractRequest:
                            dataDriver.documentsDriver.contractRequest,
                          insurensePolicy:
                            dataDriver.documentsVehicle.insurensePolicy,
                          criminalLetter:
                            dataDriver.documentsDriver.criminalLetter,
                          address: dataDriver.documentsDriver.address,
                          vehicleCardConstancy:
                            dataDriver.documentsVehicle.vehicleCardConstancy,
                        });
                      },
                    },
                  ];

                  // Reenviar SMS action (only if cognitoStatus is FORCE_CHANGE_PASSWORD)
                  if (params.row.driver?.cognitoStatus === "FORCE_CHANGE_PASSWORD") {
                    menuItems.push({
                      label: "Reenviar SMS de invitación",
                      loading: false,
                      onClick: () => {
                        drivers.resendInvitationSMS(params.row.driver?.id, params.row.driver?.tel);
                      },
                    });
                  }

                  const unpaidEarning = drivers.getUnpaidEarning(params.row.driver?.id);
                  if (unpaidEarning > 0) {
                    menuItems.push({
                      label: `Pagar saldo ($${unpaidEarning} MXN)`,
                      loading: false,
                      onClick: () => {
                        const driverName = getFormattedFullName(
                          params.row.driver?.name,
                          params.row.driver?.lastName,
                          "Conductor"
                        );
                        openPaymentModal(params.row.driver?.id, driverName, unpaidEarning);
                      },
                    });
                  }

                  menuItems.push({
                    label: "Eliminar perfil",
                    loading: false,
                    onClick: () => {
                      drivers.onDeleteToDriver(params.row.driver);
                    },
                  });

                  return classVeryTable.renderColMenu(menuItems);
                }
              ),
            }}
          />
        </DivTablePage>
        {/* PANEL PROFILE */}
        <PanelProfile refSlide={refDivMain} />
      </styles.DivMain>

      {/* MODAL CONFIRM ACTION */}
      <ModalAsk />

      {/* PAYMENT MODAL */}
      {paymentModal.visible && (
        <styles.ModalBackdrop onClick={() => setPaymentModal(prev => ({ ...prev, visible: false }))}>
          <styles.ModalContent onClick={(e) => e.stopPropagation()}>
            <styles.ModalHeader>
              <div>
                <h3>Pagar Saldo a Favor</h3>
                <span>{paymentModal.driverName}</span>
              </div>
              <styles.CloseButton onClick={() => setPaymentModal(prev => ({ ...prev, visible: false }))}>
                <span className="material-symbols-outlined" style={{ fontSize: 20 }}>close</span>
              </styles.CloseButton>
            </styles.ModalHeader>
            <styles.ModalBody>
              <styles.BalanceDisplay>
                <span className="label">Saldo Pendiente Acumulado:</span>
                <span className="value">${paymentModal.totalBalance.toFixed(2)} MXN</span>
              </styles.BalanceDisplay>

              <div>
                <h4 style={{ margin: "0 0 8px 0", fontSize: 14, fontWeight: 600, color: "#374151" }}>
                  Viajes que generaron este saldo:
                </h4>
                <styles.TripsTableWrapper>
                  {paymentModal.loadingCoupons ? (
                    <div className="empty">Cargando viajes...</div>
                  ) : paymentModal.coupons.length === 0 ? (
                    <div className="empty">No se encontraron viajes con cupones pendientes</div>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>Viaje ID</th>
                          <th>Fecha</th>
                          <th>Pasajero</th>
                          <th>Cupón</th>
                          <th style={{ textAlign: "right" }}>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentModal.coupons.map((coupon, i) => (
                          <tr key={i}>
                            <td>#{coupon.tripId}</td>
                            <td>{new Date(coupon.requestDate).toLocaleDateString()}</td>
                            <td>{coupon.passengerName}</td>
                            <td>{coupon.code}</td>
                            <td className="money" style={{ textAlign: "right" }}>
                              ${Math.min(coupon.amount, coupon.tripCost).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </styles.TripsTableWrapper>
              </div>

              <styles.FormField>
                <label>Monto a Liquidar (MXN)</label>
                <input
                  type="number"
                  value={paymentModal.amount}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPaymentModal(prev => ({ ...prev, amount: val }));
                  }}
                  max={paymentModal.totalBalance}
                  min="0.01"
                  step="0.01"
                />
                <span className="help">
                  Puedes editar este campo para realizar un pago parcial. Máximo: ${paymentModal.totalBalance.toFixed(2)}
                </span>
              </styles.FormField>

              <styles.FormField>
                <label>Comentario / Referencia de Pago</label>
                <input
                  type="text"
                  placeholder="ej. Transferencia bancaria SPEI"
                  value={paymentModal.comment}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPaymentModal(prev => ({ ...prev, comment: val }));
                  }}
                />
              </styles.FormField>
            </styles.ModalBody>
            <styles.ModalFooter>
              <VeryBtnFill
                label="Cancelar"
                colorTheme={classVeryBtnFill.COLOR_THEME.WHITE_S1}
                onClick={() => setPaymentModal(prev => ({ ...prev, visible: false }))}
                disabled={paymentModal.loading}
              />
              <VeryBtnFill
                label={paymentModal.loading ? "Procesando..." : "Confirmar Pago"}
                colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
                onClick={handlePayBalance}
                disabled={paymentModal.loading || paymentModal.loadingCoupons}
              />
            </styles.ModalFooter>
          </styles.ModalContent>
        </styles.ModalBackdrop>
      )}
    </>
  );
};

export default ContentDriversPage;
